<template>
    <div>
        <SelectOrMakeProductModal
            ref="SelectOrMakeProductModal"
            :button-disabled="isAddProductButtonDisabled"
            :search-disabled="isSearchProductDisabled"
            :modifier-function="modifyCreateProductRequestPayload"
            @input="onComponentNameEnter"
            @selected="onProductSelect"
            @created="onComponentSelect"
            @modalHide="clearAddComponentProductVariables"
        >
            <template #additional-content>
                <Transition name="fade">
                    <b-row v-if="showProductTypeSelector">
                        <b-col>
                            <div class="demo-inline-spacing text-center">
                                <div class="mt-0">
                                    {{ $t('Component(ProductComponentsDefinition):select-product-type') }}
                                </div>
                                <b-form-radio
                                    name="product-type"
                                    class="custom-control-primary mt-0"
                                    :value="typePurchased"
                                    v-model="productType"
                                    @change="productTypeChange"
                                >
                                    {{ $t('Component(Text):product-type-purchased') }}
                                </b-form-radio>
                                <b-form-radio
                                    name="product-type"
                                    :value="typeOwn"
                                    class="custom-control-primary mt-0"
                                    v-model="productType"
                                    @change="productTypeChange"
                                >
                                    {{ $t('Component(Text):product-type-own') }}
                                </b-form-radio>
                            </div>
                        </b-col>
                    </b-row>
                </Transition>
                <Transition name="fade">
                    <b-row v-if="isSupplierSelectorVisible" class="mt-1">
                        <b-col>
                            <b-form-group
                                :label="supplierNameLabel"
                                label-for="supplierProductName"
                            >
                                <b-form-input
                                    id="supplierProductName"
                                    class="input-bg-warning"
                                    v-model="supplierProductName"
                                    :state="supplierProductNameState"
                                    @input="supplierProductNameChange"
                                />
                            </b-form-group>

                            <b-form-group
                                :label="supplierIdLabel"
                                label-for="supplierProductId"
                            >
                                <b-form-input
                                    id="supplierProductId"
                                    v-model="supplierProductId"
                                />
                            </b-form-group>

                            <SupplierSelector
                                class="mt-2"
                                :selected="suppliers"
                                @change="suppliersChange"
                            />
                        </b-col>
                    </b-row>
                </Transition>
            </template>
        </SelectOrMakeProductModal>
        <EditComponent
            ref="editComponent"
            @save="updateComponent"
            @delete="remove"
        />
        <InstructionText>
            {{ $t('Page(ReceivedRequest):Component(Instruction):component-tree-definition') }}
        </InstructionText>
        <div class="d-flex align-items-center">
            <span class="pr-1">{{ $t('Component(ReceivedRequestConcernElements):choose-order') }}</span>
            <OrderSelector
                :default-value="order"
                @input="onOrderChange"
            />
        </div>
        <Button
            variant="primary"
            class="mt-1 mb-1"
            size="sm"
            :disabled="isAppendComponentButtonDisabled"
            @click="appendComponent"
        >
            {{ isTopDownOrder ? $t('Component(Button):add-component-top-down') : $t('Component(Button):add-component-bottom-up') }}
        </Button>
        <ComponentsTree
            :hierarchy="hierarchy"
            @toggle="onItemToggle"
            @checked="onComponentCheck"
            @unchecked="onComponentUncheck"
            @componentIncluded="componentIncluded"
        >
            <template #title="data">
                <div>
                    <div>
                        <span v-if="data.item.identifier">{{ data.item.identifier }},</span> {{ data.item.title }}.
                        <span v-if="data.item.supplier" class="mr-50"><b-badge>{{ data.item.supplier.title }}</b-badge></span>
                        <span v-if="hierarchy !== data.item">
                            {{ $t('Page(ReceivedRequest):Component(Text):component-number-of-units', {numberOfUnits: data.item.numberOfUnits}) }}
                            <b-button
                                variant="flat-primary"
                                class="btn-icon btn-sm ml-50"
                                v-if="hierarchy !== data.item"
                                @click="edit(data.item)"
                            >
                                <feather-icon icon="EditIcon" />
                            </b-button>
                        </span>
                    </div>
                </div>
            </template>
        </ComponentsTree>
    </div>
</template>

<script>
import { BRow, BCol, BFormRadio, BFormInput, BFormGroup, BButton, BBadge } from 'bootstrap-vue'
import {Button} from "@core/components/common";
import SelectOrMakeProductModal from "@core/components/product/SelectOrMakeProductModal";
import OrderSelector from "@/views/request/received/flow/components/vertiacal-steps/OrderSelector";
import ComponentsTree from "@/views/request/received/flow/components/concern-element/ComponentsTree";
import {ConcernElementPlacementOrder, ProductProvider} from "@core/domain/product";
import {ProductIdentifiers, ProductNames, ProductType, setNameOrId} from "@/libs/product";
import {SupplierSelector} from "@core/components/supply-chain";
import ReplyTabProductSection from "@core/mixins/ui/reply-tab-product-section";
import EditComponent from "@/views/request/received/flow/components/vertiacal-steps/EditComponent";
import InstructionText from "@core/components/common/instructions/InstructionText.vue";

export default {
    mixins: [ReplyTabProductSection],
    components: {
        InstructionText,
        SelectOrMakeProductModal, OrderSelector, ComponentsTree, Button, BRow, BCol, BFormRadio, SupplierSelector,
        BFormInput, BFormGroup, BButton, EditComponent, BBadge
    },
    props: {
        product: {
            required: true,
        },
        request: {
            required: true
        }
    },
    data() {
        return {
            productNameTypingInterval: null,
            productNameTyping: false,
            suppliers: [],
            productType: null,
            isProductSelected: false,
            typeOwn: ProductType.OWN,
            typePurchased: ProductType.PURCHASED_UNDEFINED_SUPPLIER,

            supplierProductName: '',
            supplierProductNameState: null,
            supplierProductId: '',

            checkedComponent: null,
            order: ConcernElementPlacementOrder.TOP_DOWN,
            hierarchy: {
                children: []
            },
        }
    },

    methods: {
        supplierProductNameChange() {
            this.supplierProductNameState = this.supplierProductName.length > 3;
        },
        productTypeChange() {

        },
        componentIncluded(toComponent, component) {
            this.fetchHierarchy();
            this.$emit('componentIncluded');
        },
        onComponentUncheck(component) {
            if (this.checkedComponent) {
                this.$set(this.checkedComponent, 'selected', false);
                this.checkedComponent = null;
            }
        },
        onComponentCheck(component) {
            if (this.checkedComponent && this.checkedComponent.id !== component.id) {
                this.checkedComponent.selected = false;
            }
            this.checkedComponent = component;
            this.resolveProductType();
        },
        checkSelectedComponent(component) {
            if (!this.checkedComponent) {
                return;
            }
            component = component || this.hierarchy;
            if (component.id === this.checkedComponent.id) {
                this.checkedComponent = component;
                this.checkedComponent.selected = true;
            } else {
                component.children.forEach(this.checkSelectedComponent);
            }
        },

        getRequestProduct() {
            return ProductProvider(this.product.id);
        },

        initHierarchy(h) {
            this.$set(h, 'selected', false);
            h.children.forEach(c => {
                c.parent = h;
                this.initHierarchy(c);
            });
        },

        flattenHierarchy(hierarchy) {
            const container = {};
            let id = hierarchy.id;
            container[id] = hierarchy;

            const flatten = (hierarchy, id) => {
                hierarchy.children.forEach(c => {
                    id = id + '_' + c.id;
                    container[id] = c;

                    flatten(c, id);
                });
            };
            flatten(hierarchy, id);

            return container;
        },

        restoreHierarchyState(flattenOldHierarchy, flattenNewHierarchy) {
            Object.keys(flattenNewHierarchy).forEach(key => {
                if (flattenOldHierarchy.hasOwnProperty(key)) {
                    this.$set(flattenNewHierarchy[key], 'isOpen', flattenOldHierarchy[key].isOpen);
                }
            });
        },

        onItemToggle(item, isOpen) {
            item.isOpen = isOpen;
        },

        fetchHierarchy() {
            return this.getRequestProduct()
                .getHierarchy()
                .then(h => {
                    const hierarchy = JSON.parse(JSON.stringify(h));
                    this.initHierarchy(hierarchy)

                    if (this.hierarchy.id) {
                        this.restoreHierarchyState(
                            this.flattenHierarchy(this.hierarchy),
                            this.flattenHierarchy(hierarchy)
                        );
                    }

                    this.hierarchy = hierarchy;
                    if (this.hierarchy.children.length === 0) {
                        this.hierarchy.selected = true;
                        this.checkedComponent = this.hierarchy;
                    } else {
                        this.checkSelectedComponent();
                    }

                    this.openHierarchyRoot();
                    this.emitValidity();
                });
        },

        onComponentNameEnter(name) {
            this.isProductSelected = false;

            this.productNameTypingInterval = setTimeout(() => {
                if (!this.isProductSelected) {
                    this.productNameTyping = true;
                }
            }, 1500);
        },

        onProductSelect(product) {
            this.isProductSelected = true;
        },

        modifyCreateProductRequestPayload(payload) {
            if (this.isProductSelected) {
                return payload;
            }

            if (this.isPurchasedComplexProduct) {
                payload.type = ProductType.COMPONENT_TO_COMPLEX_PURCHASED_PRODUCT;
                return payload;
            }

            payload.type = this.productType;
            const populateAttributes = () => {
                setNameOrId(payload.names, ProductNames.SUPPLIERS_PRODUCT_NAME, this.supplierProductName);
                if (this.supplierProductId) {
                    setNameOrId(payload.identifiers, ProductIdentifiers.SUPPLIERS_PRODUCT_ID, this.supplierProductId);
                }
            }

            if (ProductType.PURCHASED_UNDEFINED_SUPPLIER === this.productType) {
                populateAttributes();
            }

            if (this.productType === ProductType.PURCHASED) {
                payload.suppliers = this.suppliers.map(s => s.id);
                populateAttributes();
            }

            return payload;
        },

        suppliersChange(idList, suppliers) {
            this.suppliers = suppliers;
            this.typePurchased = ProductType.PURCHASED;
            this.productType = ProductType.PURCHASED;
        },

        clearAddComponentProductVariables() {
            this.suppliers = [];
            this.productType = null;
            this.isProductSelected = false;
            this.productNameTyping = false;
            this.typePurchased = ProductType.PURCHASED_UNDEFINED_SUPPLIER;
            this.supplierProductName = '';
            this.supplierProductId = '';
        },

        onComponentSelect(component, numberOfUnits) {
            if (this.checkedComponent) {
                if (this.order === ConcernElementPlacementOrder.TOP_DOWN) {
                    ProductProvider(this.checkedComponent.id)
                        .includeComponent(component, numberOfUnits)
                        .then(() => {
                            this.getRequestProduct().hierarchyChanged();
                            this.fetchHierarchy();
                            this.refreshComponents();
                            this.$emit('componentIncluded');
                        });
                } else {
                    //  here we need to do the following
                    //  - select or create a product -> $p
                    //  - find component's parent $cp
                    //  - exclude component from component's parent hierarchy ($c)
                    //  - include $p to $cp
                    //  - include $c to $p
                    //  - $c -> $p -> $cp -> ... -> complex product
                    let componentToAttach = this.checkedComponent.parent;
                    let productToAttach = ProductProvider(componentToAttach.id);
                    productToAttach
                        .excludeComponent(this.checkedComponent)
                        .then(() => {
                            return productToAttach.includeComponent(component, numberOfUnits);
                        })
                        .then(() => {
                            return ProductProvider(component.id).includeComponent(this.checkedComponent);
                        })
                        .then(() => {
                            this.getRequestProduct().hierarchyChanged();
                            this.fetchHierarchy();
                            this.refreshComponents();
                            this.$emit('componentIncluded');
                        })
                    ;
                }

            }
        },

        appendComponent() {
            //  it should not be possible to insert intermediate component on top level product
            if (this.order === ConcernElementPlacementOrder.BOTTOM_TOP) {
                if (this.checkedComponent.id === this.product.id) {
                    this.$swal({
                        title: 'Warning!',
                        text: 'You can\'t insert intermediate component for top level product',
                        icon: 'warning',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                    return;
                }
            }

            this.$refs.SelectOrMakeProductModal.show();
        },

        onOrderChange(order) {
            this.order = order;

            this.resolveProductType();
        },

        resolveProductType() {
            // if we have
            // - own complex product
            // - order is bottom up
            // - checked component is not top hierarchy component
            // - checked component is complex
            // we should set by default type OWN Product
            // otherwise set null
            if (this.request.isComplexProduct && ProductType.OWN === this.product.type && this.checkedComponent !== this.hierarchy) {
                if (this.order === ConcernElementPlacementOrder.BOTTOM_TOP) {
                    this.productType = ProductType.OWN;
                } else {
                    this.productType = null;
                }
            }
        },

        refreshComponents() {
            this.$emit('refreshComponents');
        },

        emitValidity() {
            this.$emit('validityChanged', this.isStepValid);
        },

        openHierarchyRoot() {
            this.$set(this.hierarchy, 'isOpen', true);
        },

        isRemoveButtonVisible(item) {
            if (item.id === this.hierarchy.id) {
                return false;
            }
            return false === this.$store.getters.subscription.isActive && false === item.isComplex;
        },

        remove(item) {
            ProductProvider(item.parent.id).excludeComponent(item).then(() => {
                this.getRequestProduct().hierarchyChanged();
                this.fetchHierarchy();
                this.refreshComponents();
            });
        },

        edit(item) {
            this.$refs.editComponent.show(
                item,
                {
                    isDeleteButtonVisible: this.isRemoveButtonVisible(item),
                    showSupplierOptions: this.isSupplierSelectorVisible
                }
            );
        },

        updateComponent(component, options) {
            if (component.numberOfUnits !== options.numberOfUnits) {
                component.numberOfUnits = options.numberOfUnits;
                this.$emit('updateComponent', component);
            }
        }
    },

    computed: {
        isStepValid() {
            return this.hierarchy.children.length > 0;
        },

        isAppendComponentButtonDisabled() {
            if (!this.checkedComponent) {
                return true;
            }
            if (this.order === ConcernElementPlacementOrder.TOP_DOWN) {
                return !this.checkedComponent.mayIncludeComponents;
            }

            return false;
        },

        isTopDownOrder() {
            return this.order === ConcernElementPlacementOrder.TOP_DOWN;
        },

        isPurchasedComplexProduct() {
            return this.request.isComplexProduct
                && (ProductType.PURCHASED === this.product.type || ProductType.PURCHASED_UNDEFINED_SUPPLIER === this.product.type);
        },

        showProductTypeSelector() {
            if (this.isPurchasedComplexProduct) {
                return false;
            }

            if (this.order === ConcernElementPlacementOrder.BOTTOM_TOP && this.checkedComponent !== this.hierarchy) {
                return false;
            }

            return this.productNameTyping && ProductType.OWN === this.product.type && !this.isProductSelected
        },

        isSupplierSelectorVisible() {
            return this.showProductTypeSelector
                && (ProductType.PURCHASED === this.productType || ProductType.PURCHASED_UNDEFINED_SUPPLIER === this.productType);
        },

        isSupplierDefined() {
            return this.suppliers instanceof Array && this.suppliers.length > 0;
        },

        isSearchProductDisabled() {
            return this.isPurchasedComplexProduct;
        },

        isAddProductButtonDisabled() {
            if (this.isPurchasedComplexProduct) {
                return false;
            }
            if (!this.isProductSelected) {
                if (this.productType === ProductType.OWN) {
                    return false;
                }
                if (this.isSupplierSelectorVisible && this.supplierProductName) {
                    if (this.productType === ProductType.PURCHASED && this.isSupplierDefined) {
                        return false;
                    }
                    if (this.productType === ProductType.PURCHASED_UNDEFINED_SUPPLIER) {
                        return false
                    }
                }
            }
            return !this.isProductSelected
        },
    },

    created() {
        this.clearAddComponentProductVariables();
    },

    watch: {
        product() {
            if (!this.hierarchy.id && this.product.id) {
                this
                    .fetchHierarchy()
                    .then(() => {
                        this.checkedComponent = this.hierarchy;
                        this.openHierarchyRoot();
                        this.checkSelectedComponent();
                    });
            }
        }
    }
}
</script>
